<p-dialog styleClass="notes" #notes [closable]="false" [(visible)]="displayCommentAdd" [modal]="true"
  [style]="{width: '55%', minWidth: '55%'}" appendTo="body">
  <p-header>
    <h5 class="p-d-inline-block p-mb-0">
      {{currentHeaderTitle}}
    </h5>
    <div class="pull-right p-text-right" *ngIf="formType !=='Add' && !callFromTimeLine">
      <div [hidden]="this.tempComment?.objectId == 8">
        <button pButton icon="pi pi-ellipsis-v" class="p-button-text p-button-rounded" (click)="noteMenu.toggle($event)"
          label="">
        </button>
        <p-menu #noteMenu [popup]="true" [appendTo]="notes" [model]="items" [baseZIndex]="100000">
        </p-menu>
      </div>
    </div>
  </p-header>

  <div *ngIf="currentObjectType == 'Opportunity' && selectedCase?.callFromAccounts" class="arrow-steps">
    <div style="overflow-x: auto; width: 100%;">

      <ng-container *ngFor="let stage of caseStages; let i = index;">
        <div *ngIf="stage?.id != null" class="step" [ngClass]="{
              'current': (selectedCase.opportunityStageId == stage.id) ||
                  ([5, 6].includes(selectedCase.opportunityStageId) && stage.id === -1),
              'handPointer': !editPermission
          }" [ngStyle]="{
              width: caseStages.length > 2 ?
              (100 / (caseStages.length - 1)) + '%' : '10%', maxWidth: 100 / caseStages.length > 2
              ? (100 / (caseStages.length - 1)) + '%' : '15%'
          }" [class.inactive]="selectedCase.statusId !== 1 || selectedCase.isConvertedToAccount"
          (click)="openUpdateStagePopupChild(stage.id, 'Add')">
          <span>
            {{ stage.name }}
          </span>
        </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="currentObjectType == 'Case' && selectedCase?.callFromAccounts" class="arrow-steps">
    <div style="overflow-x: auto; width: 100%;">

      <ng-container *ngFor="let stage of caseStages; let i = index;">
        <div *ngIf="stage?.id != null" class="step" [ngClass]="{
              'current': (selectedCase.ticketStageId == stage.id) ||
                  ([6, 10].includes(selectedCase.ticketStageId) && stage.id === -1),
              'handPointer': !editPermission
          }" [ngStyle]="{
              width: caseStages.length > 2 ?
              (100 / (caseStages.length - 1)) + '%' : '10%', maxWidth: 100 / caseStages.length > 2
              ? (100 / (caseStages.length - 1)) + '%' : '15%'
          }" [class.inactive]="selectedCase.statusId !== 1 || selectedCase.isConvertedToAccount"
          (click)="openUpdateStagePopupChild(stage.id, 'Add')">
          <span>
            {{ stage.name }}
          </span>
        </div>
      </ng-container>
    </div>
  </div>

  <ng-container *ngIf="formType === 'View'">
    <div class="p-grid p-pt-3">
      <div class="p-col p-lg-12 p-md-12">
        <h6 class="p-mb-1" style="display:flex;justify-content: space-between;">
          {{currentObjectType ? currentObjectType : currentComment.objectType}} - {{ currentComment.userName}} -
          {{currentComment.stage && currentComment.stage.name? currentComment.stage.name:
          getStageName(currentComment.stageId)}}
          <div *ngIf="currentComment?.createdDate">
            <div>Stage changed Date</div>
            <span>
              {{ currentComment.createdDate | localDate:'MM/DD/YYYY' }}
            </span>
          </div>
          <div
            *ngIf="(isClosed || (callFromTimeLine && closeStages.includes(currentComment.stage.name))) && currentComment?.closedDate">
            <div>{{currentComment?.stage?.name}} Date</div>
            <span>
              {{ currentComment.closedDate | localDate:'MM/DD/YYYY' }}
            </span>
          </div>

        </h6>
        <p style="white-space: pre; text-wrap: wrap;" class="p-col p-lg-12 p-md-12 commentContent"
          [innerHTML]="currentComment.comment">
        </p>
        <p class="pull-right" *ngIf="currentShowPublicPrivateBtn">
          <b>{{currentComment.isPublic? 'Public': 'Private'}}</b>
        </p>

        <div *ngIf="isClosed && commentForm && commentForm.value.reasonId && commentForm.value.reasonId.length>0">
          <h6>Reasons</h6>
          <p *ngFor="let item of commentForm.value.reasonId">
            {{item.name}}
          </p>
        </div>

        <div *ngIf="resolvedUnresolvedReasonList?.length > 0">
          <h6>Reasons</h6>
          <p *ngFor="let reason of resolvedUnresolvedReasonList">
            {{reason.name}}
          </p>
        </div>

      </div>
    </div>

  </ng-container>

  <ng-container *ngIf="formType !=='View'">
    <form #createComment="ngForm" (ngSubmit)="saveComment()" [formGroup]="commentForm">

      <!-- Closed Opportunity Lead -->
      <div *ngIf="isClosed && closedStages.length>0" class="p-field p-formgrid p-grid">
        <div class="p-col-6">
          <label class="p-mt-4">Closed Stage<span style="color: red;">*</span></label>
          <p-dropdown [options]="closedStages" id="closedStages" formControlName="stageId" optionLabel="name"
            appendTo="body" (onChange)="onselectStage($event.value)">
          </p-dropdown>
        </div>
        <div
          *ngIf="commentForm.value.stageId && commentForm.value.stageId.id && closeLostStage && commentForm.value.stageId.id==closeLostStage.id"
          class="p-col-6">
          <label class="p-mt-4">{{closeLostUnQualifiedTitle}}<span style="color: red;">*</span></label>
          <p-multiSelect [options]="closeLostUnQualifiedReasons" id="closeLostUnQualifiedReasons"
            formControlName="reasonId" placeholder="Choose reason" optionLabel="name" appendTo="body">
          </p-multiSelect>
          <small class="p-invalid"
            *ngIf="isSubmit && (!commentForm.value.reasonId || commentForm.value.reasonId.length == 0)">Reason is
            required</small>
        </div>
        <div
          *ngIf="commentForm.value.stageId && commentForm.value.stageId.id && closeWonStage && commentForm.value.stageId.id==closeWonStage.id"
          class="p-col-6">
          <label class="p-mt-4">{{closeWonQualifiedTitle}}<span style="color: red;">*</span></label>
          <p-multiSelect [options]="closeWonQualifiedReasons" id="closeWonQualifiedReasons" formControlName="reasonId"
            placeholder="Choose reason" optionLabel="name" appendTo="body">
          </p-multiSelect>
          <small class="p-invalid"
            *ngIf="isSubmit && (!commentForm.value.reasonId || commentForm.value.reasonId.length == 0)">Reason is
            required</small>
        </div>
      </div>

      <div *ngIf="showResolvedUnresolvedArea" class="p-field p-formgrid p-grid">
        <div class="p-col-6">
          <label class="p-mt-4">Closed Stage<span style="color: red;">*</span></label>
          <p-dropdown [options]="resolvedUnresolvedStages" id="resolvedUnresolvedStage"
            formControlName="resolvedUnresolvedStage" optionLabel="name" appendTo="body"
            (onChange)="onChangeResolvedUnresolvedStage($event)">
          </p-dropdown>
        </div>
        <div class="p-col-6" *ngIf="showResolvedReasonsList">
          <label class="p-mt-4">{{resolvedReasonTitle}}<span style="color: red;">*</span></label>
          <p-multiSelect [options]="resolvedReasons" id="closeWonQualifiedReasons"
            formControlName="resolvedUnresolvedReasons" placeholder="Choose reason" optionLabel="name" appendTo="body">
          </p-multiSelect>
          <small class="p-invalid"
            *ngIf="getResolvedUnresolvedReasons.invalid && (getResolvedUnresolvedReasons.touched || getResolvedUnresolvedReasons.dirty)">Reason
            is required</small>
        </div>
        <div class="p-col-6" *ngIf="showUnResolvedReasonsList">
          <label class="p-mt-4">{{unresolvedReasonTitle}}<span style="color: red;">*</span></label>
          <p-multiSelect [options]="unResolvedReasons" id="closeWonQualifiedReasons"
            formControlName="resolvedUnresolvedReasons" placeholder="Choose reason" optionLabel="name" appendTo="body">
          </p-multiSelect>
          <small class="p-invalid"
            *ngIf="getResolvedUnresolvedReasons.invalid && (getResolvedUnresolvedReasons.touched || getResolvedUnresolvedReasons.dirty)">Reason
            is required</small>
        </div>
        <div class="p-col-6">
          <label for="name">{{closedReasonTitle}} Date<span style="color: red;">*</span></label>
          <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
            dateFormat="mm/dd/yy" yearRange="1900:2100" [ngModelOptions]="{standalone: true}"
            formControlName="closedDate">
          </p-calendar>
        </div>
      </div>

      <div class="p-field p-formgrid p-grid">
        <div *ngIf="leadOwnerSettings?.enabled" class="p-col-12 p-lg-6">
          <label for="name">Stage Owner</label>
          <p-dropdown [options]="ownerList" placeholder="Select lead stage Owner" inputId="stageOwnerId"
            formControlName="stageOwnerId" optionLabel="name" optionValue="id" [filter]="true" [filterBy]="'name'"
            appendTo="body" (onChange)="onSelectStageOwner($event.value)">
          </p-dropdown>
        </div>
        <div *ngIf="isClosed" class="p-col-12 p-lg-6">
          <label for="name">{{closeDateTitle}} Date<span style="color: red;">*</span></label>
          <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
            dateFormat="mm/dd/yy" yearRange="1900:2100" [ngModelOptions]="{standalone: true}"
            formControlName="closedDate">
          </p-calendar>
        </div>
        <div class="p-col-12">
          <div class="p-d-flex p-jc-between">
            <p-selectButton *ngIf="currentShowPublicPrivateBtn" formControlName="isPublicOption" [options]="options"
              [ngModelOptions]="{standalone: true}" optionLabel="label">
            </p-selectButton>
            <!-- <div class="field-checkbox" *ngIf="objectType == 'Case' ">
              <p-checkbox [(ngModel)]="resolution" [binary]="true" inputId="binary"></p-checkbox>
              <span for="binary" class="p-ml-2">Resolution</span>
            </div> -->
          </div>
          <label class="p-mt-4">Comments <span style="color: red;">*</span></label>
          <div class="p-mt-2">
            <textarea rows="5" cols="100" formControlName="comment" placeholder="Enter Comment" pInputTextarea
              id="comment" name="comment" required>
          </textarea>
          </div>
          <small class="p-invalid" *ngIf="comment?.invalid && (comment?.touched || comment?.dirty)">Comment is
            required</small>
          <div class="field-checkbox p-mt-2" *ngIf="objectType == 'Case' ">
            <p-checkbox [binary]="true" inputId="binary" formControlName="notifyClient"></p-checkbox>
            <span for="binary" class="p-ml-2">Notify Client</span>
          </div>
        </div>
      </div>
    </form>
  </ng-container>

  <ng-template pTemplate="footer">
    <button *ngIf="formType ==='View'" pButton label="Close" (click)="cancelComment()"
      class="p-button-secondary"></button>
    <button *ngIf="formType !=='View'" pButton label="Cancel" (click)="cancelComment()"
      class="p-button-secondary"></button>
    <button *ngIf="formType !=='View'" [disabled]="commentForm.invalid || disabledAddComment" pButton label="Save"
      (click)="saveComment()"></button>
  </ng-template>
</p-dialog>